import { FunctionComponent, ReactNode } from "react";
import { Navigate } from "react-router";

import { AppRole } from "../../../../@api";

import { RouteConstants } from "../../../models/enums";
import { useStore } from "../../../stores/StoreContext";

interface IFeatureGuardProps {
  children: ReactNode;
  role: AppRole;
}

export const FeatureGuard: FunctionComponent<IFeatureGuardProps> = ({ children, role }) => {
  const { permissionStore } = useStore();

  if (!permissionStore.userPermissions || !permissionStore.hasRole(role)) {
    return <Navigate to={`/${RouteConstants.LandingPage}`} replace />;
  }

  return children;
};
